<template>
  <div v-if="pending" class="agency-number-notice" role="status">
    <strong>Your workspace is ready to set up.</strong>
    Add clients, connect integrations, and configure your agency. Phone number purchases require team approval after your introduction.
    <a href="https://lsacommand.com/discovery" target="_blank" rel="noopener">Book your introduction</a>
    <button :disabled="checking" @click="check">{{ checking ? 'Checking…' : 'Check approval' }}</button>
    <span v-if="error">{{ error }}</span>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({ pending: false, checking: false, error: '' }),
  mounted() { this.check() },
  methods: {
    async check() {
      this.checking = true
      this.error = ''
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/access-status`, {
          headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt }
        })
        this.pending = data.pending && data.workspace_restricted === false
      } catch (e) { this.error = 'Unable to check approval. Please try again.' }
      finally { this.checking = false }
    }
  }
}
</script>
<style scoped>
.agency-number-notice{padding:16px 20px;margin-bottom:20px;background:#fff8e6;border:1px solid #ead9a7;border-radius:5px;color:#654d17;font-size:13px;line-height:1.7}.agency-number-notice strong{display:block}.agency-number-notice a,.agency-number-notice button{display:inline-block;margin:8px 16px 0 0;text-decoration:underline;color:inherit}.agency-number-notice button:disabled{opacity:.6}
</style>
